import React, { useState } from "react";

const questions = [
  {
    q: "You and your partner just got a bonus. What’s the plan?",
    a: ["Save it all", "Treat ourselves", "Hmm... not sure yet", "Half for savings, half for fun"]
  },
  {
    q: "How do you track monthly spending?",
    a: ["Budget spreadsheet or app", "Mentally (or not at all)", "I try to ignore it", "Manual records & receipts"]
  },
  {
    q: "When your partner buys something big without telling you, you feel…",
    a: ["Worried – where’s the budget?!", "Happy – they deserve it!", "Unsure how to bring it up", "Curious – let’s discuss it soon"]
  },
  {
    q: "You and your partner have a ‘money talk’ — you…",
    a: ["Focus on reducing expenses", "Focus on dream goals", "Feel nervous or avoid it", "Have a clear plan to go through"]
  },
  {
    q: "Your idea of a fun weekend is…",
    a: ["Stay home, cook, chill", "Shop or dine out", "Netflix and zone out", "Plan something affordable but fun"]
  },
  {
    q: "What do you usually do with your savings?",
    a: ["Keep in FD or Tabung Haji", "Don’t really save", "No clear plan", "Invest with a goal"]
  },
  {
    q: "Your partner forgot to pay a bill. You…",
    a: ["Immediately panic", "Say \"relax, we’ll pay it tomorrow\"", "Stay silent, but feel stressed", "Set a reminder system next time"]
  },
  {
    q: "What motivates you to manage money well?",
    a: ["Avoiding financial disaster", "Wanting more lifestyle freedom", "I don’t think about it unless forced", "Building a future together"]
  },
  {
    q: "How do you feel about debt?",
    a: ["Avoid it at all costs", "Okay if it helps enjoy life", "Not sure how it works", "Manageable if planned wisely"]
  },
  {
    q: "What’s your ideal money system as a couple?",
    a: ["Everything joint, tightly controlled", "Separate — I want freedom", "No system — let’s go with the flow", "Hybrid — mix of shared + personal"]
  }
];

const types = ["Saver", "Spender", "Avoider", "Planner"];

const results = {
  Saver: {
    description:
      "Cautious, disciplined, and future-focused. Savers are great at managing resources but may need to loosen up to maintain harmony.",
    keywords: "Security, Order, Budgeting",
    strengths: "Planning, Avoiding Debt, Financial Discipline",
    challenges: "Too rigid, Conflict over spending"
  },
  Spender: {
    description:
      "Optimistic and lifestyle-focused. Spenders enjoy the present and need structure to avoid regret or guilt.",
    keywords: "Fun, Experience, Expression",
    strengths: "Generosity, Enjoying life, Confidence",
    challenges: "Impulsiveness, Overspending"
  },
  Avoider: {
    description:
      "Passive or overwhelmed. Avoiders tend to delay decisions and need support to gain financial clarity.",
    keywords: "Anxiety, Indifference, Insecurity",
    strengths: "Adaptability, Calmness",
    challenges: "Inaction, Lack of planning"
  },
  Planner: {
    description:
      "Structured and balanced. Planners communicate well and take action but must avoid over-controlling tendencies.",
    keywords: "Clarity, Structure, Communication",
    strengths: "Goal setting, Communication, Stability",
    challenges: "Burnout, Overthinking"
  }
};

export default function MoneyPersonalityQuiz() {
  const [step, setStep] = useState(0);
  const [scores, setScores] = useState([0, 0, 0, 0]);
  const [showResult, setShowResult] = useState(false);

  const handleAnswer = (index) => {
    const updatedScores = [...scores];
    updatedScores[index] += 1;
    setScores(updatedScores);
    if (step === questions.length - 1) setShowResult(true);
    else setStep(step + 1);
  };

  const getResult = () => {
    const maxIndex = scores.indexOf(Math.max(...scores));
    return types[maxIndex];
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      {!showResult ? (
        <div>
          <h2 className="text-xl font-bold mb-4">{`Question ${step + 1}`}</h2>
          <p className="mb-4">{questions[step].q}</p>
          {questions[step].a.map((answer, i) => (
            <button
              key={i}
              onClick={() => handleAnswer(i)}
              className="block w-full text-left px-4 py-2 my-2 border rounded hover:bg-gray-100"
            >
              {answer}
            </button>
          ))}
        </div>
      ) : (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-2">You are a {getResult()}!</h2>
          <p className="mb-2 font-medium">{results[getResult()].description}</p>
          <p><strong>Keywords:</strong> {results[getResult()].keywords}</p>
          <p><strong>Strengths:</strong> {results[getResult()].strengths}</p>
          <p><strong>Challenges:</strong> {results[getResult()].challenges}</p>
        </div>
      )}
    </div>
  );
}
